import React, { useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Collapse } from "react-collapse";
import { AiFillLinkedin, AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { IoIosArrowUp, IoIosArrowDown  } from "react-icons/io";
import logo from "../../assets/imgs/navbar/logo_AMC.svg";
import logoSky from "./images/logo-sky.svg";
import rastrea from "./images/rastrea.svg";
import cotiza from "./images/cotiza.svg";
import restricciones from "./images/restricciones.svg";
import nosotros from "./images/nosotros.svg";
import alertas from "./images/alertas.svg";
import facturacion from "./images/facturacion.svg";
import certificados from "./images/certificados.svg";
import "./Footer.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ScrollToTop from "../scrollToTop/scrollToTop";
import ScrollToDynamic from "../scrollToDynamic/scroolToDynamic";
import { FaPhone } from "react-icons/fa";

function Footer(props) {
  const [tNabvar] = useTranslation("navbar");
  const [tFooter] = useTranslation("footer");
  const [isCheckboxCollapseOpen, setIsCheckboxCollapseOpen] = useState(true);
  const [isCheckboxCollapseOpen2, setIsCheckboxCollapseOpen2] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

   // Estado para controlar si el acordeón está abierto o cerrado
  const [isOpen, setIsOpen] = useState(false);

  // Función para cambiar el estado al hacer clic
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const onChange = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen(checked),
    [setIsCheckboxCollapseOpen]
  );

  const onChange2 = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen2(checked),
    [setIsCheckboxCollapseOpen2]
  );

  const handleClickPrivacy = () => {
    let lastRouteUs = "";
    let lastRouteEs = "";
    if (
      !sessionStorage.getItem("routeEn") ||
      !sessionStorage.getItem("routeEs") ||
      !localStorage.getItem("lng")
    ) {
      lastRouteEs = "/";
      lastRouteUs = "/";
    } else {
      lastRouteUs = `${sessionStorage.getItem("routeEn")}`;
      lastRouteEs = `${sessionStorage.getItem("routeEs")}`;
    }
    navigate(`/${tNabvar("category-services.privacy")}`, {
      state: { us: lastRouteUs, es: lastRouteEs },
    });
  };

  return (
    <React.StrictMode>
      <footer className="container-fluid footer-redesign">
        <div className="container container-wide margin-bottom-custom">
          <div className="row pt-5 pb-4">
            <div className="col-12 col-lg-4 d-flex flex-column">
              <p className="need-help">{tFooter("column1.text-1")}</p>
              <h4>{tFooter("column1.text-2")}</h4>
              <p className="your-comments">{tFooter("column1.text-3")}</p>
              <Link className="btn-footer text-decoration-none mb-3" to="/faqs">{tFooter("column1.text-19")}</Link>
              <Link className="btn-footer-blue text-decoration-none mb-3" to={`/${tNabvar("category-services.contact")}`}><FaPhone />&nbsp;&nbsp;&nbsp;(55) 51330237</Link>

              <div className="mt-4 follow-us-container d-flex align-items-center">
                <p className="follow-us mb-0">{tFooter("column1.text-5")}:</p>
                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/amxcargo/" id="linkLinkedinFooter" className="no-a-footer">
                  <AiFillLinkedin className="follow-us-icon ms-3" />
                </a>
              </div>
              <a rel="noreferrer" href={tFooter("column1.skyteamLink")} target="_blank" className="sky-logo-container mt-3" name="skyTeamButtonFooter" id="skyTeamButtonFooter">
                <img src={logoSky} alt="Skyteam Cargo Logo" />
              </a>
            </div>
            <div className="col-12 col-lg-3 margin-izquierda">
              <h5 className="footer-column-title">{tFooter("column2.text-title")}</h5>

              <div className="shipment-list-container">
                <div className="shipment-item">
                  <img className="shipment-icon" src={rastrea} alt="" />
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.track")}`}
                  >
                    {tFooter("column2.text-2")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <img className="shipment-icon" src={cotiza} alt="" />
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.quote")}`}
                  >
                    {tFooter("column2.text-3")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <img className="shipment-icon" src={restricciones} alt="" />
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.shipments")}/${tNabvar("prepare-shipment-submenu.restricciones")}`}
                  >
                    {tFooter("column2.text-4")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <img className="shipment-icon" src={facturacion} alt="" />
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to="https://portalfacturacioncargo.aeromexico.com/Portal/Cargo/Account/Login"
                    target="blank"
                  >
                    {tFooter("column2.text-7")}
                  </Link>
                </div>
                <p className="copyright-text custom-mt">{tFooter("column2.text-8")}</p>
              </div>

            </div>
            <div className="col-12 col-lg-3 margin-izquierda">
              <h5 className="footer-column-title">{tFooter("column3.text-title")}</h5>

              <div className="shipment-list-container">

                <div className="shipment-item">
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.alert")}`}
                  >
                    {tFooter("column2.text-6")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.contracts")}`}
                  >
                    {tFooter("column3.text-2")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.about-us")}/${tNabvar("category-services.aeromexico-cargo")}`}
                  >
                    {tFooter("column2.text-5")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.compliance")}`}
                    target="blank"
                  >
                    {tFooter("column3.text-3")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.compliance")}/#comp_conduct_info_conta`}
                    target="blank"
                  >
                    {tFooter("column3.text-7")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to='/'
                  >
                    Aeroméxico
                  </Link>
                </div>

              </div>

            </div>
            <div className="col-12 col-lg-2 margin-izquierda">
              <h5 className="footer-column-title">{tFooter("column4.text-title")}</h5>

              <div className="shipment-list-container">

                <div className="shipment-item">
                  <Link
                    id="linkRestrictionsFooter"
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.compliance")}/#compliance_ethics`}
                  >
                    {tFooter("column3.text-6")}
                  </Link>
                </div>
                <div className="shipment-item custom-mt">
                  <a
                    id="linkPrivacyFooter"
                    className="shipment-link-footer"
                    onClick={handleClickPrivacy}
                  >
                    {tFooter("column3.text-5")}
                  </a>
                </div>
                <div className="shipment-item custom-mt">
                  <Link
                    className="shipment-link-footer"
                    to={`/${tNabvar("category-services.contact")}`}
                  >
                    {tFooter("column1.text-4")}
                  </Link>
                </div>

              </div>

            </div>
          </div>

          <div className="row copyright-padding pb-4">
            <div className="col copyright-space">
              <p className="copyright-text mb-0">
                ©Copyright {new Date().getFullYear()}{" "}
                    {tFooter("column4.text-1")}
              </p>
              <img className="" src={certificados} alt="" />
            </div>
          </div>
        </div>
      </footer>
    </React.StrictMode>
  );
}

export default Footer;